import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstLetter'
})
export class FirstLetterPipe implements PipeTransform {

  transform(value: string): string {
    return value.match(/\b(\w)/g).join('').slice(0, 2).toUpperCase();
  }

}
